import {
  fetchGraphQL
} from '../Connections';

import {
  getFieldListString
} from './util';

export async function queryListCredits(variables, fields) {
  const query = `
    query listCredits(
      $limit: Int,
      $offset: Int,
      $filters: [Filter],
      $filter_expressions: [FilterExpression],
      $order: Order,
      $orders: [Order]
    ) {
      listCredits(
        limit: $limit,
        offset: $offset,
        filters: $filters,
        filter_expressions: $filter_expressions,
        order: $order,
        orders: $orders
      ) {
        ${getFieldListString(fields)}
      }
    }
  `;

  return fetchGraphQL({ query, variables });
}

export async function queryListCreditEntries(variables, fields) {
  const query = `
    query listCreditEntries(
      $limit: Int,
      $offset: Int,
      $filters: [Filter],
      $filter_expressions: [FilterExpression],
      $order: Order,
      $orders: [Order]
    ) {
      listCreditEntries(
        limit: $limit,
        offset: $offset,
        filters: $filters,
        filter_expressions: $filter_expressions,
        order: $order,
        orders: $orders
      ) {
        ${getFieldListString(fields)}
      }
    }
  `;

  return fetchGraphQL({ query, variables });
}

export async function queryGetCredit(variables, fields) {
  const query = `
    query getCredit($credit_id: String!) {
      getCredit(credit_id: $credit_id) {
        ${getFieldListString(fields)}
      }
    }
  `;

  return fetchGraphQL({ query, variables });
}

export async function queryCreateCredit(variables, fields) {
  const query = `
    mutation createCredit(
      $subscription_id: String!,
      $payment_id: String!,
      $amount: PositiveInteger!,
      $notes: String,
      $application_type: CreditApplicationTypeEnum,
      $application_date: String,
      $credit_entry: CreditEntryInput,
      $payment_type: String!
    ) {
      createCredit(
        subscription_id: $subscription_id,
        payment_id: $payment_id,
        amount: $amount,
        notes: $notes,
        application_type: $application_type,
        application_date: $application_date,
        credit_entry: $credit_entry,
        payment_type: $payment_type
      ) {
        ${getFieldListString(fields)}
      }
    }
  `;

  return fetchGraphQL({ query, variables });
}

export async function queryReverseCredit(variables) {
  const query = `
    mutation reverseCredit(
      $creditId: String!,
      $applicationDate: String,
      $amount: PositiveInteger,
      $amountTax1: Int,
      $amountTax2: Int,
      $amountTax3: Int,
      $amountTax4: Int
    ) {
      reverseCredit(
        creditId: $creditId,
        applicationDate: $applicationDate,
        amount: $amount,
        amountTax1: $amountTax1,
        amountTax2: $amountTax2,
        amountTax3: $amountTax3,
        amountTax4: $amountTax4
      )
    }
  `;
  return fetchGraphQL({ query, variables });
}

export async function queryIncreaseCredit(variables) {
  const query = `
    mutation increaseCredit(
      $creditId: String!,
      $applicationDate: String,
      $amount: PositiveInteger!,
      $amountTax1: PositiveInteger,
      $amountTax2: PositiveInteger,
      $amountTax3: PositiveInteger,
      $amountTax4: PositiveInteger,
    ) {
      increaseCredit(
        creditId: $creditId,
        applicationDate: $applicationDate,
        amount: $amount,
        amountTax1: $amountTax1,
        amountTax2: $amountTax2,
        amountTax3: $amountTax3,
        amountTax4: $amountTax4,
      )
    }
  `;
  return fetchGraphQL({ query, variables });
}

export async function queryWriteOffCredit(variables) {
  const query = `
    mutation writeOffCredit(
      $creditId: String!,
      $amount: PositiveInteger!,
      $amountTax1: PositiveInteger,
      $amountTax2: PositiveInteger,
      $amountTax3: PositiveInteger,
      $amountTax4: PositiveInteger,
    ) {
      writeOffCredit(
        creditId: $creditId,
        amount: $amount,
        amountTax1: $amountTax1,
        amountTax2: $amountTax2,
        amountTax3: $amountTax3,
        amountTax4: $amountTax4,
      )
    }
  `;
  return fetchGraphQL({ query, variables });
}

export async function queryGetCreditBalances(variables) {
  const query = `
    query getCreditBalances($creditId: String!) {
      getCreditBalances(creditId: $creditId) {
        amount,
        amount_tax_1,
        amount_tax_2,
        amount_tax_3,
        amount_tax_4
      }
    }
  `;
  return fetchGraphQL({ query, variables });
}

export async function queryGetCreditsForInvoicePayment(variables, fields) {
  const query = `
    query getCreditsForInvoicePayment($invoiceId: String!) {
      getCreditsForInvoicePayment(invoiceId: $invoiceId) {
        ${getFieldListString(fields)}
      }
    }
  `;
  return fetchGraphQL({ query, variables });
}
